export const STATUS_DISPLAY: Record<string, string> = {
  NOT_YET_DUE: "Upcoming",
  DUE_SOON: "Due Soon",
  OVERDUE: "Overdue",
  AWAITING_EVIDENCE: "Awaiting certificate",
  COMPLETED: "Completed",
  CANCELLED: "Cancelled",
  NO_INSTANCE: "No Instance",
};

export const STATUS_BADGE_VARIANT: Record<
  string,
  "success" | "neutral" | "warning" | "error" | "brand"
> = {
  NOT_YET_DUE: "neutral",
  DUE_SOON: "warning",
  OVERDUE: "error",
  AWAITING_EVIDENCE: "warning",
  COMPLETED: "success",
  CANCELLED: "neutral",
  NO_INSTANCE: "neutral",
};

export const ROLE_DISPLAY: Record<string, string> = {
  MANAGER: "Manager",
  DEPUTY_MANAGER: "Deputy Manager",
  LEADER: "Leader",
  PRACTITIONER: "Practitioner",
};

// Repeat frequency options (NAU-302). The value strings match the API's
// ComplianceTaskFrequency enum; labels are the human-facing presets.
export const FREQUENCY_OPTIONS: { value: string; label: string }[] = [
  { value: "WEEKLY", label: "Weekly" },
  { value: "MONTHLY", label: "Monthly" },
  { value: "SIX_MONTHLY", label: "6-monthly" },
  { value: "YEARLY", label: "Yearly" },
  { value: "FIVE_YEARLY", label: "5-yearly" },
];

export function getStatusKey(status: string | null | undefined): string {
  return status ?? "NO_INSTANCE";
}

/**
 * Order a task's category ids by the catalog's sortOrder so badges read in the
 * same canonical order as the pickers. `catalog` is expected already sorted
 * (the API returns categories by sortOrder); unknown/inactive ids sink last.
 */
export function sortCategoryIdsByCatalog(
  categoryIds: string[],
  catalog: { id: string }[],
): string[] {
  const rank = new Map(catalog.map((c, i) => [c.id, i]));
  return [...categoryIds].sort(
    (a, b) =>
      (rank.get(a) ?? Number.MAX_SAFE_INTEGER) -
      (rank.get(b) ?? Number.MAX_SAFE_INTEGER),
  );
}
